import { Component } from 'preact';
import { GRAPH_VIEW } from '../../utils/constants';
import Selector from '../selector';

/**
 * This component displays a selector for the view mode of observation panelgraphs.
 *
 * props:
 * - activeView: the active panelgraph view (see GRAPH_VIEW enum)
 * - onViewChange: function which gets called when the user selected a different view
 * - exclude: optional array of GRAPH_VIEW values to be excluded from the selector
 * - monthlyRainfall: optionally change the "Daily Rainfall" label to "Monthly Rainfall"
 * - includeWindrose: optionally include a wind rose option
 */
class ObservationsViewSelector extends Component {

	constructor(props) {
		super(props);

		this.options = [
			{ value: GRAPH_VIEW.COMBINED, label: 'Overview' },
			{ value: GRAPH_VIEW.WIND, label: 'Wind' },
			{ value: GRAPH_VIEW.TEMPERATURE, label: 'Temperature' },
			{ value: GRAPH_VIEW.RAIN, label: 'Daily Rainfall' },
			{ value: GRAPH_VIEW.RAIN_HOURLY, label: 'Hourly Rainfall' },
			{ value: GRAPH_VIEW.PRESSURE, label: 'Pressure' },
			{ value: GRAPH_VIEW.HUMIDITY, label: 'Humidity' }
		];

		this.onViewChange = this.onViewChange.bind(this);
	}

	onViewChange(option) {
		this.props.onViewChange(option.value);
	}

	render(props) {

		const options = props.exclude
			? this.options.filter(opt => props.exclude.indexOf(opt.value) === -1)
			: [].concat(this.options);

		if (props.monthlyRainfall) {
			const opt = this.options.filter(opt => opt.value === GRAPH_VIEW.RAIN)[0];
			opt.label = 'Monthly Rainfall';
		}

		if (props.includeWindrose) {
			options.push({
				value: GRAPH_VIEW.WIND_ROSE,
				label: 'Wind Rose'
			});
		}

		return (
			<Selector options={options}
			          selectedValue={props.activeView}
			          onOptionSelect={this.onViewChange} />
		);
	}

}

export default ObservationsViewSelector;



// WEBPACK FOOTER //
// ./components/observations-view-selector/index.js